import {
  Component,
  ElementRef,
  HostListener,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Event, NavigationEnd, Router } from '@angular/router';
import { DeviceDetectorService } from 'ngx-device-detector';
import { PerfectScrollbarDirective } from 'ngx-perfect-scrollbar';
import { Observable } from 'rxjs/Observable';
import { filter, pluck, publishReplay, refCount } from 'rxjs/operators';
import { Subscription } from 'rxjs/Subscription';
import { UserNotificationCounter } from '../core/models/user-notification-counter';
import { ASSISTANT_ENABLED } from '../core/config/modularized.config';
import { schedulerSimulatorRoute } from '../core/config/routes.config';
import { CollapseService } from '../core/services/visual/collapse.service';
import { isAppDashboardPrivilege } from '../core/utils/jwt.utils';
import { environment } from '../../environments/environment';
import { TranslationService } from './../core/services/translation.service';
import { DashboardService } from './dashboard.service';

const NOTIFICATIONS_INTERVAL = 60000;
export const APP_TITLE_KEY = 'app.title';
const DEVICE_MOBILE_CLASS = 'mobile';
const DEVICE_TABLET_CLASS = 'tablet';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css'],
})
export class DashboardComponent implements OnInit, OnDestroy {
  @ViewChild(PerfectScrollbarDirective) main: PerfectScrollbarDirective;
  @ViewChild('container') container: ElementRef;
  private subscription: Subscription;
  deviceClass: string;
  asideOpen = false;
  portrait: boolean;
  desktop: boolean;
  canSeeAssistant = false;
  private assistantPrerequisite = false;
  userNotificationsCounter$: Observable<UserNotificationCounter>;

  constructor(
    public collapseService: CollapseService,
    private router: Router,
    private deviceService: DeviceDetectorService,
    private translationService: TranslationService,
    private titlesService: Title,
    private activatedRoute: ActivatedRoute,
    private dashboardService: DashboardService
  ) {}

  ngOnInit() {
    const title = this.translationService.getTranslationSync(APP_TITLE_KEY);
    this.subscription = this.router.events
      .pipe(filter((event: Event) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.main.scrollToTop();
        this.updateAssistantVisibility();
      });
    this.detectDevice();
    this.portrait = this.isPortrait();
    this.desktop = this.deviceService.isDesktop();
    this.assistantPrerequisite =
      environment.assistantModularized === ASSISTANT_ENABLED && isAppDashboardPrivilege();
    this.updateAssistantVisibility();
    this.titlesService.setTitle(title);
    this.userNotificationsCounter$ = this.activatedRoute.data.pipe(
      pluck('userNotificationsCounter')
    );
    this.refreshNotifications();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  @HostListener('window:orientationchange')
  getOrientation() {
    const previousPortrait = this.isPortrait();
    this.portrait = !previousPortrait;
  }

  onToggleAside(asideOpen) {
    this.asideOpen = asideOpen;
  }

  private detectDevice(): any {
    if (this.deviceService.isMobile()) {
      this.deviceClass = DEVICE_MOBILE_CLASS;
    } else if (this.deviceService.isTablet()) {
      this.deviceClass = DEVICE_TABLET_CLASS;
    }
  }

  public isPortrait() {
    const width = this.container.nativeElement.offsetWidth;
    const height = this.container.nativeElement.offsetHeight;

    return height > width;
  }

  refreshNotifications() {
    setInterval(() => {
      this.userNotificationsCounter$ = this.dashboardService
        .getUserNotificationIsNotReadCounter()
        .pipe(publishReplay(1), refCount());
    }, NOTIFICATIONS_INTERVAL);
  }

  private updateAssistantVisibility() {
    this.canSeeAssistant = this.assistantPrerequisite && this.isSimulatorRoute(this.router.url);
  }

  private isSimulatorRoute(url: string) {
    // Tolerate query params (?a=1) and fragments (#x) on the simulator URL.
    const path = (url || '').split('?')[0].split('#')[0];
    return path === schedulerSimulatorRoute || path.startsWith(`${ schedulerSimulatorRoute }/`);
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/dashboard/dashboard.component.ts